/* IYP The Pleasure Press index · BATCH B (the stories) · assets/iyp-press-cards.js · 2026-09-19
   Loaded only by sections/template--blog.liquid on the Pleasure Press (it replaces the old assets/iyp-blog-cards.js,
   which the disabled blurb section used to load; the two must never load on one page: both answer to
   window.iypFitBlogCards). Source: the approved prototype's iyp-blog-cards.proposed.js (round 5), byte for byte except
   (theme port 9/19) rows are grouped by LAYOUT position (offsetTop), not the on-screen box, so the theme's scroll-in
   fade (a translateY animation on each card, staggered) can never split one row into several.
   What it does: card titles and the lead title set like the post title (phrase points first, then the most even lines;
   no closing period, a curly apostrophe; one line only when it stays within 88% of its photo and its row neighbours are
   one line too; one title size per card tier on desktop); the lead's dek set on even lines, the words never change.
   Without script: CSS text-wrap:balance, full text.
   ---- the prototype's own notes follow ----
   PROTOTYPE (blog index design review 2026-09-19, round 5: comment only, the 464 px title cap is gone from the CSS; round 4: one line only within 88% of the photo, the row rule (one line
   only beside one-line neighbours); round 3: one title size per card tier, 'living well' bound in the dek, no sentence
   tail opening a dek line): the live fitter with PROTOTYPE-SPEC.md §4 edits (JOBS, lead title prep, lead dek as an excerpt, one-line fallback, Cormorant Garamond 500 load).
   FIX ROUND (critique 12:06): 12 px inset on every set; one-line fallback only when no phrase/even set exists; card-title floor
   follows the column under 375; one title size per desktop row; the lead dek prefers a set whose lines are all >= .80.
   IYP 2026-09-19 (build-site fix round 2) The Pleasure Press blog page only: card titles and excerpts.
   Titles: set like the post title (phrase points first, then the most even lines; no closing period, a curly
   apostrophe). Generated from build/article/fit-core.js by build/site-fix2/build_blog_fit.py; re-run it when
   fit-core.js changes. Excerpts: shown in full, the words never change, lines chosen to be even (a sentence end
   first), a dash never starts a line, a hyphenated word never splits. Desktop rows: equal title and excerpt
   heights so every Read more sits on one line. Without script: CSS text-wrap:balance, full text. */
(function () {
  var D = document, W = window;
  if (W.iypFitBlogCards) { W.iypFitBlogCards(); return; }
  if (!D.body || !D.body.classList.contains('template-blog')) return;
  // theme port 9/19: an element's top in the page from layout (offsetTop), which a CSS transform never moves
  function layTop(el) { var y = 0; while (el) { y += el.offsetTop || 0; el = el.offsetParent; } return y; }
  // display lines: the post title and the TURN THE PAGE card title (a chooser picks the breaks), pull quotes (pq mode)
  // fix round 9/19 (critique defect 3): in a column narrower than 331 px (the 375 phone's) the card-title floor
  // follows the column (28 at 331, 23 at the 320 phone's 276, 26 in the 308 px columns at 769), so the approved
  // phrase set 'Hyaluronic Acid: / Your Face Already Loves It / Your Tissue Wants It Too' and the even two-line
  // 'The Mediterranean Already / Solved Intermittent Fasting' still hold inside the 12 px inset instead of wrapping
  // mid-sentence. The lead title's floor is 34 on the phone (its CSS size scales with the nameplate under 390,
  // critique defect 4).
  var JOBS = [
    { sel: 'body.template-blog .blog-post-card__title > a', mode: 'lines', floorPhone: 28, floorDesk: 28, maxLines: 3,
      colFloor: function (col) { return col >= 331 ? 28 : Math.max(22, Math.floor(28 * col / 331)); } },
    { sel: 'body.template-blog .iyp-lead__title > a',        mode: 'lines', floorPhone: 34, floorDesk: 44, maxLines: 3 }
  ];
  // a line should not END on these (an article or possessive belongs to the next word) ...
  var HARD = { a: 1, an: 1, the: 1, your: 1, my: 1, her: 1, his: 1, its: 1, our: 1, their: 1, this: 1, these: 1, those: 1 };
  var ARTICLE = { a: 1, an: 1, the: 1 };
  // ... except as one unit with the preposition before it ('for the', 'in the', 'on the'): that pair may end a line
  // at a cost (fix round 2: the approved 'On Surfing for the / First Time at 50'). A bare article or possessive at a
  // line end (after a colon, a verb, a noun: 'Vitamin E: The /', 'Loves It. Your /') is still never a candidate.
  var PREP = { of: 1, to: 1, 'in': 1, on: 1, at: 1, by: 1, 'for': 1, 'with': 1, from: 1, into: 1, onto: 1, about: 1, over: 1, under: 1, through: 1, after: 1, before: 1, without: 1, like: 1, across: 1, around: 1, near: 1, between: 1, among: 1, beyond: 1, toward: 1, towards: 1 };
  // words that end a capitalised noun phrase run (pronouns and relative words: 'The Paper You / Read', 'The Showjumper Who / Quit')
  var RUNSTOP = { you: 1, it: 1, we: 1, they: 1, she: 1, he: 1, i: 1, who: 1, which: 1, that: 1, what: 1 };
  function isCap(t) { return /^[A-Z0-9\u00c0-\u00de]/.test(t.split('\u00a0')[0].replace(/^[\u2018\u201c"'(]+/, '')); }
  // ... and should rather not end on these (a preposition, conjunction or relative word opens a phrase)
  var SOFT = { of: 1, to: 1, 'in': 1, on: 1, at: 1, by: 1, 'for': 1, 'with': 1, and: 1, or: 1, but: 1, nor: 1, from: 1, into: 1, as: 1, than: 1, that: 1, who: 1, which: 1, when: 1, where: 1, are: 1, is: 1, was: 1, were: 1, be: 1 };
  // a phrase opens before these (her list: before with / and / for / that)
  var OPEN = { 'with': 1, and: 1, 'for': 1, that: 1, who: 1, which: 1, when: 1, where: 1, because: 1 };
  var STRONG = /[:.?!;\u2014]$/;
  // tokens are split on ordinary spaces only, so '&nbsp;'-bound words ('A&nbsp;Bioavailability') stay one token
  function bareEnd(t) { var p = t.split('\u00a0'); return p[p.length - 1].toLowerCase().replace(/[^a-z\u2019']/g, ''); }
  function bareStart(t) { return t.split('\u00a0')[0].toLowerCase().replace(/[^a-z\u2019']/g, ''); }

  function lineWidths(el) {
    // fix round 9/19: text boxes only, and never the hidden mid-title full stop (.iyp-tdot is 0 px wide on the page,
    // but its glyph box would count ~7 px against the inset)
    var rs = [], g = [], tw = D.createTreeWalker(el, NodeFilter.SHOW_TEXT), tn;
    while ((tn = tw.nextNode())) {
      if (!tn.data.trim() || (tn.parentElement && tn.parentElement.closest('.iyp-tdot'))) continue;
      var r = D.createRange(); r.selectNodeContents(tn);
      var cr = r.getClientRects(); for (var c = 0; c < cr.length; c++) rs.push(cr[c]);
    }
    for (var i = 0; i < rs.length; i++) {
      var x = rs[i]; if (x.width < 2) continue;
      var f = null;
      for (var j = 0; j < g.length; j++) { if (Math.abs(g[j].t - x.top) < x.height / 2) { f = g[j]; break; } }
      if (!f) { f = { t: x.top, l: x.left, r: x.right }; g.push(f); }
      f.l = Math.min(f.l, x.left); f.r = Math.max(f.r, x.right);
    }
    return g.map(function (a) { return a.r - a.l; });
  }

  // ── lines mode ────────────────────────────────────────────────────────────────────────────────
  function source(el) {
    if (el.__iypText == null) el.__iypText = (el.getAttribute('data-iyp-text') || el.textContent).replace(/[ \t\n\r]+/g, ' ').replace(/^ | $/g, '');   // not \s: that would eat the &nbsp; bindings
    return el.__iypText;
  }
  function restore(el) {
    el.style.removeProperty('font-size');
    if (el.__iypDone) { el.textContent = source(el); el.__iypDone = false; el.classList.remove('iyp-lined'); }
  }
  function render(el, toks, lines, size) {
    while (el.firstChild) el.removeChild(el.firstChild);
    for (var i = 0; i < lines.length; i++) {
      var a = lines[i][0], b = lines[i][1], sp = D.createElement('span');
      sp.className = 'iyp-ln';
      var words = toks.slice(a, b + 1), last = words[words.length - 1];
      var hideDot = i < lines.length - 1 && /[^.]\.$/.test(last);
      if (hideDot) words[words.length - 1] = last.slice(0, -1);
      sp.appendChild(D.createTextNode(words.join(' ')));
      if (hideDot) { var d = D.createElement('span'); d.className = 'iyp-tdot'; d.textContent = '.'; sp.appendChild(d); }
      el.appendChild(sp);
      if (i < lines.length - 1) el.appendChild(D.createTextNode(' '));
    }
    el.classList.add('iyp-lined');
    el.__iypDone = true;
    if (size) el.style.setProperty('font-size', size + 'px', 'important');
  }
  // fix round 9/19 (critique defect 1): every set, the one-line fallback included, is measured against the column
  // minus INSET, so no title line comes closer than 12 px to either photo edge (the NOW 'edge to edge' problem)
  var INSET = 24;
  // round 4 (critique round 3, defect 1): a title sits on one line only when that line stays within 88% of its
  // column (the photo, or the title's own 464 px measure on the larger cards). 'Vitamin E: The Quiet Second
  // Ingredient' ran 503 px across a 531.5 px photo in her 1223 window and read as edge to edge; so did 'The Case for
  // the Long Lunch' (360 of 389 at 1366). An even two-line set now wins there. When no even set exists at all, the
  // old rule still applies (one line inside the 12 px inset), so no title is ever set on uneven lines to avoid it.
  var ONE_MAX = 0.88;
  // opts.noOne (round 4, the row rule): set this title on 2 or 3 even lines at its current size, never one line and
  // never smaller; returns false (and changes nothing the caller keeps) when no 'phrase' or 'even' set exists
  function fitLines(el, job, floor, cap, opts) {
    var noOne = !!(opts && opts.noOne);
    var text = source(el);
    restore(el);
    el.__iypAll = null;
    el.__iypPick = null;
    var cs = W.getComputedStyle(el);
    var base = Math.round(parseFloat(cs.fontSize));   // the approved CSS size
    // cap (fix round, desktop rows): the row's size when a neighbour had to step down, so one row = one size
    var css = cap && cap < base ? cap : base;
    if (css !== base) el.style.setProperty('font-size', css + 'px', 'important');
    floor = Math.min(floor, css);
    var toks = text.split(' ').filter(Boolean), m = toks.length;
    // the title <a> is a block as wide as the column (the photo; round 5: no 464 px cap any more, her 'one line when it
    // fits' rule); the lines must stay 12 px clear of both edges, and one line stays within 88% of the photo (ONE_MAX)
    var colW = el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var avail = colW - INSET, oneMax = Math.min(avail, colW * ONE_MAX);
    if (job.colFloor) floor = Math.min(floor, job.colFloor(avail + INSET));
    if (noOne) floor = css;   // the row rule never changes a title's size, only its lines
    if (!css || m < 2 || avail < 50) return false;
    // one line at the approved size, within 88% of the column: leave it alone (a title never shrinks onto one line)
    var nat = lineWidths(el);
    if (!noOne && nat.length <= 1 && (nat[0] || 0) <= oneMax) { el.__iypPick = { s: css, n: 1, E: 1, cls: 'natural' }; return true; }
    var probe = el.cloneNode(false);
    ['id', 'style', 'data-animate', 'data-animate-order', 'data-iyp-text'].forEach(function (k) { probe.removeAttribute(k); });
    probe.style.cssText = 'position:absolute!important;left:0;top:0;visibility:hidden!important;white-space:nowrap!important;width:auto!important;max-width:none!important;min-width:0!important;margin:0!important;padding:0!important;font-size:' + css + 'px!important;text-wrap:nowrap';
    el.parentNode.insertBefore(probe, el);
    var memo = {};
    function wid(a, b) {   // tokens a..b on one line at the approved size (a mid-title '.' at a line end is hidden)
      var k = a + ',' + b;
      if (memo[k] == null) {
        var words = toks.slice(a, b + 1), last = words[words.length - 1];
        if (b < m - 1 && /[^.]\.$/.test(last)) words[words.length - 1] = last.slice(0, -1);
        probe.textContent = words.join(' ');
        memo[k] = probe.getBoundingClientRect().width;
      }
      return memo[k];
    }
    var strongIdx = [];
    for (var i = 0; i < m - 1; i++) if (STRONG.test(toks[i])) strongIdx.push(i);
    // every way to set the words on 2 or 3 lines (ends = index of each line's last word)
    var splits = [];
    for (var b1 = 0; b1 < m - 1; b1++) {
      splits.push([b1, m - 1]);
      if (job.maxLines >= 3) for (var b2 = b1 + 1; b2 < m - 1; b2++) splits.push([b1, b2, m - 1]);
    }
    // Her rule, in order: break at the natural phrase points first (after a colon or a mid-title sentence end),
    // then take the most even split. Every candidate is scored; the pick comes from the first class that has one:
    //   'phrase' every colon / sentence end ends a line, each phrase's own lines are even (2 lines >= .78,
    //            3 lines >= .80) and no line is under 60% of the longest (a short lead-in phrase reads as the
    //            title's first phrase: 'Hyaluronic Acid: / Your Face Already Loves It / Your Tissue Wants It Too');
    //   'even'   two lines >= .78 or three lines >= .80 of each other;
    //   then the least bad. A line never holds one lone word, and ends on an article or possessive (a, the,
    //   your ...) only together with the preposition before it ('On Surfing for the / First Time at 50'), at a
    //   cost; splitting a capitalised noun phrase right after its article ('for the First / Time') costs more.
    //   Within a class the fewest lines win when a two-line set reaches .85 (the critique's rule), then the
    //   lowest cost (uneven lines, a soft break such as a dangling 'for', 'for the', a smaller size).
    var all = [];
    for (var s = css; s >= floor; s--) {
      var k = s / css;
      for (var q = 0; q < splits.length; q++) {
        var ends = splits[q], n = ends.length, ws = [], a = 0, fits = true, lone = false;
        for (var e = 0; e < n; e++) {
          var w = wid(a, ends[e]) * k;
          if (w > avail) { fits = false; break; }
          if (ends[e] === a && m >= 3) lone = true;
          ws.push(w); a = ends[e] + 1;
        }
        if (!fits) continue;
        var mx = Math.max.apply(null, ws), mn = Math.min.apply(null, ws), E = mn / mx;
        var cost = (1 - E) * 10, hard = lone, used = 0, pen = 0;
        for (e = 0; e < n - 1; e++) {
          var t = toks[ends[e]], nx = toks[ends[e] + 1], bw = bareEnd(t);
          var lineStart = e ? ends[e - 1] + 1 : 0;
          if (STRONG.test(t)) { cost -= 1.0; used++; }
          else if (HARD[bw]) {
            // 'for the' as one unit may end a line (a cost, not a ban); a bare article / possessive may not
            var pv = ends[e] > lineStart ? toks[ends[e] - 1] : '';
            if (pv && !STRONG.test(pv) && PREP[bareEnd(pv)]) pen += ARTICLE[bw] ? 0.9 : 1.2;
            else { cost += 3; hard = true; }
          }
          else if (SOFT[bw]) cost += 0.6;
          if (OPEN[bareStart(nx)]) cost -= 0.2;
          // splitting a capitalised noun phrase right after its article ('for the First / Time', 'The Quiet / Second')
          // costs more than ending on 'for the'
          if (ends[e] - 1 >= lineStart && ARTICLE[bareEnd(toks[ends[e] - 1])] && !STRONG.test(t) && isCap(t) && isCap(nx) &&
              !RUNSTOP[bw] && !RUNSTOP[bareStart(nx)] && !SOFT[bareStart(nx)] && !OPEN[bareStart(nx)]) pen += 1.2;
        }
        cost += pen;
        cost += (strongIdx.length - used) * 0.8;
        if (lone) cost += 5;
        if (n === 3) cost += 0.4;
        cost += (css - s) / css * 4;
        var cls = 'none';
        if (!hard) {
          if (strongIdx.length && used === strongIdx.length && E >= 0.6) {
            // each phrase (the lines between two phrase breaks) must be even within itself
            var okP = true, p0 = 0, partMin = 1;
            for (e = 0; e < n; e++) {
              if (e === n - 1 || STRONG.test(toks[ends[e]])) {
                var pw = ws.slice(p0, e + 1);
                if (pw.length > 1) {
                  var pe = Math.min.apply(null, pw) / Math.max.apply(null, pw);
                  partMin = Math.min(partMin, pe);
                  if (pe < (pw.length === 2 ? 0.78 : 0.8)) okP = false;
                }
                p0 = e + 1;
              }
            }
            if (okP) { cls = 'phrase'; cost = (1 - partMin) * 10 + (1 - E) * 3 + (n === 3 ? 0.4 : 0) + (css - s) / css * 4 + pen; }
          }
          if (cls === 'none' && E >= (n === 2 ? 0.78 : 0.8)) cls = 'even';
        }
        var cand = { s: s, ends: ends, n: n, cost: cost, E: E, cls: cls };
        all.push(cand);
        if (W.__iypDebug) (el.__iypAll = el.__iypAll || []).push({ s: s, E: +E.toFixed(2), c: +cost.toFixed(2), cls: cls, t: ends.map(function (x, i) { return toks.slice(i ? ends[i - 1] + 1 : 0, x + 1).join(' '); }).join(' / ') });
      }
    }
    var oneW = wid(0, m - 1);   // proposed 9/19: the whole title on one line at the approved size
    probe.parentNode.removeChild(probe);
    var pick = null;
    ['phrase', 'even', 'none'].some(function (c) {
      var pool = all.filter(function (x) { return x.cls === c; });
      if (!pool.length) return false;
      if (pool.some(function (x) { return x.n === 2 && x.E >= 0.85; })) pool = pool.filter(function (x) { return x.n === 2; });
      pool.forEach(function (x) { if (!pick || x.cost < pick.cost) pick = x; });
      return true;
    });
    // proposed 9/19, fix round (critique defect 2, spec §4.4 as written): the one-line fallback is used ONLY when no
    // 'phrase' or 'even' set exists (the pick is 'none' or there is none), and only at a size where the one line
    // stays inside the inset. An even two-line set at the approved size always wins over squeezing onto one line
    // ('The Case for / the Long Lunch' stays two lines at 32 wherever one line at 32 does not fit).
    if (noOne) {
      // the row rule: only an even set at this size will do; otherwise the caller puts the title back as it was
      if (!pick || pick.cls === 'none' || pick.n < 2) { restore(el); return false; }
    } else if ((!pick || pick.cls === 'none') && oneW > 0) {
      for (var s1 = Math.min(css, Math.floor(avail * css / oneW)); s1 >= floor; s1--) {
        render(el, toks, [[0, m - 1]], s1 === base ? 0 : s1);
        var ln1 = lineWidths(el.querySelector('.iyp-ln'));
        if (ln1.length === 1 && ln1[0] <= avail + 0.5) { el.__iypPick = { s: s1, ends: [m - 1], n: 1, cost: 0, E: 1, cls: 'one' }; return true; }
      }
      restore(el);
      if (css !== base) el.style.setProperty('font-size', css + 'px', 'important');
    }
    if (!pick) return false;
    el.__iypPick = pick;
    var lines = [], a0 = 0;
    for (var z = 0; z < pick.ends.length; z++) { lines.push([a0, pick.ends[z]]); a0 = pick.ends[z] + 1; }
    // render, then confirm every line really is one line AND inside the inset (rounding); step down 1 px if not
    for (var s2 = pick.s; s2 >= Math.max(floor - 2, pick.s - 3); s2--) {
      if (noOne && s2 !== pick.s) break;
      render(el, toks, lines, s2 === base ? 0 : s2);
      var okAll = true, spans = el.querySelectorAll('.iyp-ln');
      for (var y = 0; y < spans.length; y++) { var lw1 = lineWidths(spans[y]); if (lw1.length > 1 || lw1[0] > avail + 0.5) { okAll = false; break; } }
      if (okAll) { pick.s = s2; return true; }
    }
    restore(el);
    el.__iypPick = null;
    return false;
  }
  function nLines(el) { return el.__iypPick ? el.__iypPick.n : lineWidths(el).length; }

  // ── pq mode: each authored quote line (.pq-line) must stay one line ────────────────────────────
  function fitPq(el, floor) {
    var parts = el.querySelectorAll('.pq-line');
    if (!parts.length) return;
    function ok() { for (var k = 0; k < parts.length; k++) { if (lineWidths(parts[k]).length > 1) return false; } return true; }
    el.style.removeProperty('font-size');
    var css = Math.round(parseFloat(W.getComputedStyle(el).fontSize));
    if (!css || ok()) return;
    for (var s = css - 1; s >= floor; s--) {
      el.style.setProperty('font-size', s + 'px', 'important');
      if (ok()) return;
    }
    el.style.removeProperty('font-size');
  }

  var lastW = 0;
  function run0(force) {
    var w = D.documentElement.clientWidth;
    if (!force && w === lastW) return;
    lastW = w;
    var desk = W.matchMedia('(min-width: 769px)').matches;
    JOBS.forEach(function (j) {
      D.querySelectorAll(j.sel).forEach(function (el) {
        var floor = desk ? j.floorDesk : j.floorPhone;
        try { if (j.mode === 'pq') fitPq(el, floor); else fitLines(el, j, floor); } catch (err) { try { restore(el); } catch (e2) {} }
      });
    });
    // fix round 9/19: one title size across the grid on desktop ('one size keeps the rows equal', PLAN change 3).
    // When a title had to step down to set even lines inside the inset, every other card title is set again at that
    // size (never bigger than the approved 32), so no row, and no row against the next, mixes sizes. The phone is one
    // column: there each card keeps its own size and only the title that needs it steps down.
    // Round 3 (9/19, the row of two larger cards): one size per card TIER, a tier being the cards of one width. The
    // two larger cards after the lead keep the approved 32 when they can; the 3-up cards share one size between them.
    if (desk) {
      var job = JOBS[0], sz = function (e) { return Math.round(parseFloat(W.getComputedStyle(e).fontSize)); };
      for (var pass = 0; pass < 4; pass++) {
        var byRow = {}, changed = false;
        D.querySelectorAll(job.sel).forEach(function (e) {
          var c = e.closest('.blog-post-card'); if (!c) return;
          var k = 'w' + Math.round(c.getBoundingClientRect().width);
          (byRow[k] = byRow[k] || []).push(e);
        });
        Object.keys(byRow).forEach(function (k) {
          var row = byRow[k]; if (row.length < 2) return;
          var mn = Math.min.apply(null, row.map(sz));
          row.forEach(function (e) {
            if (sz(e) > mn) { changed = true; try { fitLines(e, job, Math.min(job.floorDesk, mn), mn); } catch (err) { try { restore(e); } catch (e2) {} } }
          });
        });
        // round 4 (critique round 3, defect 1), the row rule: in a row of two or three cards a title sits on one line
        // only when its row neighbours do too. A one-line title beside a two- or three-line title is set again on even
        // lines at the same size ('The Case for the Long Lunch' at 1440 and 1920, 'On Surfing for the First Time at
        // 50' at 1150 and 1920); if it has no even set, it keeps its one line.
        var lines = {};
        D.querySelectorAll(job.sel).forEach(function (e) {
          var c = e.closest('.blog-post-card'); if (!c) return;
          var k = 'y' + Math.round(layTop(c));
          (lines[k] = lines[k] || []).push(e);
        });
        Object.keys(lines).forEach(function (k) {
          var row = lines[k]; if (row.length < 2) return;
          var ns = row.map(nLines);
          if (Math.max.apply(null, ns) < 2 || Math.min.apply(null, ns) > 1) return;
          row.forEach(function (e, i) {
            if (ns[i] !== 1) return;
            var s0 = sz(e), ok = false;
            try { ok = fitLines(e, job, s0, s0, { noOne: true }); } catch (err) { ok = false; }
            if (ok) changed = true;
            else { try { fitLines(e, job, Math.min(job.floorDesk, s0), s0); } catch (err2) { try { restore(e); } catch (e3) {} } }
          });
        });
        if (!changed) break;
      }
    }
  }
  // ── blog page only (build-site fix round 2) ──────────────────────────────────────────────────────
  // display text, the same as the article title (patch_article_section.py): no closing period, a curly apostrophe,
  // a lone 'A' bound to the next word. The words never change.
  function prep() {
    D.querySelectorAll('body.template-blog .blog-post-card__title > a, body.template-blog .iyp-lead__title > a').forEach(function (a) {
      if (a.hasAttribute('data-iyp-text')) return;
      var t = a.textContent.replace(/[ \t\n\r]+/g, ' ').replace(/^ | $/g, '');
      if (/[^.]\.$/.test(t)) t = t.slice(0, -1);
      t = t.replace(/'/g, '\u2019').replace(/ A /g, ' A\u00a0');
      a.textContent = t; a.setAttribute('data-iyp-text', t);
    });
    // excerpts (display only, the words never change): a curly apostrophe like the article; a dash stays at the end
    // of its line, never the start of the next; a lone 'A' / 'a' goes with the next word; the last two words travel
    // together, so no excerpt ends on one lone word
    D.querySelectorAll('body.template-blog .blog-post-card__excerpt, body.template-blog .iyp-lead__dek').forEach(function (x) {
      if (x.__iypPrep) return; x.__iypPrep = 1;
      // round 3 (critique round 2, defect 3): 'living well' is the paper's own phrase ('A Guide to Living Well'
      // sits right above the dek), so it is bound and never split across two lines ('about living / well')
      var fix = function (t) { return t.replace(/'/g, '\u2019').replace(/ ([\u2014\u2013]) /g, '\u00a0$1 ').replace(/(^|[ \u00a0])([Aa]) /g, '$1$2\u00a0').replace(/\b([Ll]iving) (well)\b/g, '$1\u00a0$2'); };
      if (!x.children.length) {   // plain-text excerpt (every 2026 post): its lines are set by excerpt() below
        var t = fix(x.textContent.replace(/[ \t\n\r]+/g, ' ').replace(/^ | $/g, ''));
        x.__iypSrc = t; x.__iypFall = t.replace(/ (\S+)$/, '\u00a0$1'); x.textContent = x.__iypFall;
        return;
      }
      // an excerpt with markup: fix its text nodes, keep hyphenated words whole, and let CSS balance the lines
      var w = D.createTreeWalker(x, NodeFilter.SHOW_TEXT), n, nodes = [];
      while ((n = w.nextNode())) if (n.data.trim()) nodes.push(n);
      nodes.forEach(function (tn, i) {
        var t = fix(tn.data);
        if (i === nodes.length - 1) t = t.replace(/ (\S+)\s*$/, '\u00a0$1');
        var parts = t.split(/(\S*\w-\w\S*)/);
        if (parts.length === 1) { tn.data = t; return; }
        var f = D.createDocumentFragment();
        parts.forEach(function (p, k) {
          if (!p) return;
          if (k % 2) { var s = D.createElement('span'); s.className = 'iyp-nw'; s.textContent = p; f.appendChild(s); }
          else f.appendChild(D.createTextNode(p));
        });
        tn.parentNode.replaceChild(f, tn);
      });
    });
  }
  // excerpts: even lines in every browser (CSS balance gives up after four lines in Chrome). Keep the number of lines
  // the card needs, then choose the breaks that make the lines most even (each line as close as possible to the
  // average), with a small preference for a break after a comma or a full stop and against ending a line on a
  // preposition or article. A hyphenated word is one token, so it never splits ('most- / loved').
  function excerpt(x) {
    var src = x.__iypSrc; if (!src) return;
    x.textContent = x.__iypFall; x.classList.remove('iyp-xset');
    var par = x.parentElement, pcs = W.getComputedStyle(par);
    // round 3: the lead dek has its own measure (max-width in the index CSS), so the lines are set for the dek's box,
    // not its column (a card excerpt fills its header, so nothing changes for the cards)
    var avail = Math.min(par.clientWidth - parseFloat(pcs.paddingLeft) - parseFloat(pcs.paddingRight), x.clientWidth || 1e9) - 2;
    var toks = src.split(' ').filter(Boolean), m = toks.length;
    if (m < 4 || avail < 120) return;
    var probe = D.createElement('span');
    probe.style.cssText = 'position:absolute!important;left:0;top:0;visibility:hidden!important;white-space:nowrap!important;padding:0!important;margin:0!important';
    x.appendChild(probe);
    var mw = function (s) { probe.textContent = s; return probe.getBoundingClientRect().width; };
    var ws = toks.map(mw), sp = mw('x x') - mw('xx');
    x.removeChild(probe);
    var P = [0]; ws.forEach(function (v, q) { P.push(P[q] + v); });
    var L = function (a, b) { return P[b + 1] - P[a] + (b - a) * sp; };
    // lines the card needs: a greedy fill at the full width
    var n = 1, cur = ws[0];
    for (var i = 1; i < m; i++) { if (cur + sp + ws[i] > avail) { n++; cur = ws[i]; } else cur += sp + ws[i]; }
    if (n < 2) return;
    // her order: a natural phrase point first (a sentence end, then a comma, colon or dash), then the most even
    // split; a line should not end on an article or possessive ('The / European'), nor, less so, on a preposition
    var endCost = function (b) {
      var t = toks[b], bw = bareEnd(t);
      // round 3 (critique round 2, note): a sentence's last word never opens the next line on its own
      // ('... will rush / you. Best read in the bath.'): that break sits inside the phrase 'will rush you.'
      if (b + 1 < m && /[.!?]$/.test(toks[b + 1]) && !/[.!?:;,]$/.test(t)) return 8;
      // round 3: her phrase points weigh more than a sliver of evenness: a sentence end, then a comma or colon, then
      // the start of a phrase (before a preposition or and / with / for / that). Breaking INSIDE a phrase ('a slow /
      // paper', 'will / rush') gets none of these, so an even set of phrase breaks wins over it.
      if (/[.!?]$/.test(t)) return -7;
      if (/[,;:\u2014]$/.test(t)) return -4;
      if (HARD[bw]) return 8;
      if (SOFT[bw]) return 2;
      var nx = b + 1 < m ? bareStart(toks[b + 1]) : '';
      if (PREP[nx] || OPEN[nx]) return -2.5;
      return 0;
    };
    // every way to set the words on n lines (each line inside the card, no line of one word, none under half the
    // average), scored: shortest / longest line, plus her phrase points (a sentence end +.04, a comma, colon or
    // dash +.015), minus an article or possessive at a line end (-.08) or a preposition (-.02)
    function part(n) {
      var tot = L(0, m - 1), T = tot / n, lo = T * 0.5, best = null, bestOk = null, ends = [];
      (function dfs(a, k, mn, mx, bonus) {
        if (k === n - 1) {
          var w = L(a, m - 1); if (m - a < 2 || w > avail || w < lo) return;
          var r = Math.min(mn, w) / Math.max(mx, w), sc = r + bonus;
          if (!best || sc > best.score) best = { score: sc, ratio: r, ends: ends.concat([m - 1]), n: n };
          // fix round 9/19: a set whose every line is >= .80 of the longest beats a phrase bonus under .80
          if (r >= 0.8 && (!bestOk || sc > bestOk.score)) bestOk = { score: sc, ratio: r, ends: ends.concat([m - 1]), n: n };
          return;
        }
        for (var b = a + 1; b < m - 1; b++) {
          var w2 = L(a, b); if (w2 > avail) break;
          if (w2 < lo) continue;
          if (L(b + 1, m - 1) > avail * (n - k - 1)) continue;
          ends.push(b); dfs(b + 1, k + 1, Math.min(mn, w2), Math.max(mx, w2), bonus - endCost(b) * 0.01); ends.pop();
        }
      })(0, 0, 1e9, 0, 0);
      return bestOk || best;
    }
    var pick = part(n);
    if (pick && pick.ratio < 0.8 && n < 6) { var p2 = part(n + 1); if (p2 && (p2.ratio >= 0.8 || p2.ratio >= pick.ratio + 0.08)) pick = p2; }
    if (!pick) return;
    n = pick.n;
    var lines = [], a2 = 0;
    pick.ends.forEach(function (e3) { lines.push(toks.slice(a2, e3 + 1).join(' ')); a2 = e3 + 1; });
    x.textContent = '';
    lines.forEach(function (ln, q) { var s3 = D.createElement('span'); s3.className = 'iyp-xl'; s3.textContent = ln; x.appendChild(s3); if (q < lines.length - 1) x.appendChild(D.createTextNode(' ')); });
    x.classList.add('iyp-xset');
    // every set line must really be one line and inside the card; if not, fall back to CSS balance
    var ok = true;
    [].forEach.call(x.querySelectorAll('.iyp-xl'), function (s4) { var lw = lineWidths(s4); if (lw.length !== 1 || lw[0] > avail + 1) ok = false; });
    if (!ok) { x.textContent = x.__iypFall; x.classList.remove('iyp-xset'); }
  }
  var lastBW = 0;
  function excerpts(force) {
    var bw = D.documentElement.clientWidth;
    if (!force && bw === lastBW) return;
    lastBW = bw;
    D.querySelectorAll('body.template-blog .blog-post-card__excerpt, body.template-blog .iyp-lead__dek').forEach(function (x) { try { excerpt(x); } catch (e) { if (x.__iypFall) { x.textContent = x.__iypFall; x.classList.remove('iyp-xset'); } } });
  }
  // desktop rows: the cards in one row get the same title and excerpt heights, so every 'Read more' sits on one line
  function rows() {
    var cards = [].slice.call(D.querySelectorAll('body.template-blog .blog-post-card'));
    var parts = ['.blog-post-card__title', '.blog-post-card__excerpt'];
    cards.forEach(function (c) { parts.forEach(function (p) { var e = c.querySelector(p); if (e) e.style.removeProperty('min-height'); }); });
    var g = {};
    cards.forEach(function (c) { var r = c.getBoundingClientRect(); if (!r.height) return; var k = Math.round(layTop(c)); (g[k] = g[k] || []).push(c); });
    Object.keys(g).forEach(function (k) {
      var row = g[k]; if (row.length < 2) return;
      parts.forEach(function (p) {
        var els = row.map(function (c) { return c.querySelector(p); }).filter(Boolean);
        var h = Math.max.apply(null, els.map(function (e) { return e.getBoundingClientRect().height; }));
        els.forEach(function (e) { e.style.setProperty('min-height', Math.ceil(h) + 'px'); });
      });
    });
  }
  // on a width change every excerpt goes back to plain wrapping text FIRST, so no line set for the old width can hold
  // a card (or the whole column) wider while the titles and excerpts are fitted again
  function unset() {
    D.querySelectorAll('body.template-blog .blog-post-card__excerpt, body.template-blog .iyp-lead__dek').forEach(function (x) {
      if (x.__iypFall && x.classList.contains('iyp-xset')) { x.textContent = x.__iypFall; x.classList.remove('iyp-xset'); }
      x.style.removeProperty('min-height');
    });
    D.querySelectorAll('body.template-blog .blog-post-card__title').forEach(function (t) { t.style.removeProperty('min-height'); });
  }
  function run(force) {
    prep();
    if (force || D.documentElement.clientWidth !== lastBW) unset();
    run0(force);
    try { excerpts(force); rows(); } catch (e) {}
  }
  W.iypFitBlogCards = function () { run(true); };
  run(true);
  if (D.fonts) {
    if (D.fonts.load) D.fonts.load('400 28px Cormorant').then(function () { run(true); }, function () {});
    if (D.fonts.load) D.fonts.load('500 22px "Cormorant Garamond"').then(function () { run(true); }, function () {});
    if (D.fonts.ready) D.fonts.ready.then(function () { run(true); });
  }
  D.addEventListener('DOMContentLoaded', function () { run(true); });
  var t; W.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { run(false); }, 120); });
})();
